import React from 'react';
import {Link, useParams} from 'react-router';
import BackLink from "../../components/BackLink";
import InfoBox from "../../components/passengerInformation/InfoBox";
import useTravelDocs from "../../hooks/useTravelDocs";
import DownloadButton from "../../components/pdf/DownloadButton";
import {getBackToDashboardText} from "../../utils/themeUtils";
import {isEventSubType} from "../../utils/miscUtils";
import { Trans, useLingui } from '@lingui/react/macro';

function BoardingPass(props) {
    const {hash} = useParams();
    
    const {passengers, bookingData} = useTravelDocs(hash);

    const {t} = useLingui();

    if(bookingData.cabinAllocated === null) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <span translate="no"><Trans id="loading">loading</Trans>...</span>
                </p>
            </div>
        )
    }

    if(bookingData.cabinAllocated === false && !isEventSubType(bookingData.bookingSubType)) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <Trans id="cabin_allocation_failed_text">Cabin allocation has not yet finished, please try again later.</Trans>
                </p>
            </div>
        )
    }

    if(bookingData.boardingPassAccessAllowed === false) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <Trans id="please_fill_travel_info_and_health_survey">Please make sure to fill out pre travel questionnaire and covid survey before accessing the boarding passes</Trans>
                </p>
            </div>
        )
    }

    if(bookingData.error) {
        return (
            <div className="container mx-auto mt-4">
                <p>
                    <Trans id="error_try_again">There has been an error, please try again later.</Trans>
                </p>
            </div>
        )
    }

    return (
        <div className="container mx-auto mt-4">
            {!hash && <BackLink to="/" text={getBackToDashboardText()}/>}

            <div className="md:flex">
                <div className="w-full md:w-2/3 md:pr-4">
                    <h1>
                        <Trans id="boarding_pass">Boarding pass</Trans>
                    </h1>
                    <InfoBox
                        classes="mt-6 md:inline-block"
                        infoText={t({id: "need_to_show_to_board_ship"})}
                    />

                    <div className="mt-4">
                        <p className="text-lg text-grey-darker">
                            <Trans id="borading_pass_download_guideline">Please use the button below to download your boarding pass. Please print a copy and bring it with you when you travel.</Trans>
                        </p>
                    </div>

                    <div className="mt-6">
                        <DownloadButton type="boarding"
                            bookingData={bookingData}
                            passengers={passengers}
                            label={t({id: "download_boarding_pass"})} />
                    </div>

                    <div className="mt-4 mb-12">
                        <Link className="hidden xl:block action-button action-button-enabled w-mobile"
                            to={{
                                pathname: t({id: "/boarding/detail"}),
                            }}
                            state= {{
                                passengers,
                                bookingData,
                            }}
                        >
                            <Trans id="view_boarding_pass">View boarding pass</Trans>
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default BoardingPass;